import React from 'react';

import { Follow as FollowButton } from '../input/Button.jsx';
import { LinkedImage } from './Image.jsx';

function Artist(props) {
    const link = `/artist/${props.d.Slug}`;
    let titleClassName;
    if (!props.multiline) {
        titleClassName = 'container--single__line';
    }

    return (
    <div className="grid grid--3">
        <div className="artist__grid">
            {props.d.ImgSrc && (
                <LinkedImage
                    alt={props.d.Name}
                    imageClass={
                        !props.fixedHeight ? 'artist__img' : 'artist__img--cover'
                    }
                    cols={4}
                    image={props.d.Image}
                    title={props.d.Name}
                    type={!props.fixedHeight ? 'fit' : 'fill'}
                    link={link}
                    {...props}
                />
            )}
            <div className="artist__info">
                <a href={link} className="box--artist__title">
                    <h4 className={titleClassName}>{props.d.Name}</h4>
                </a>
                <FollowButton data={props.d} onChange={props.onFollowChange} />
            </div>
        </div>
      </div>
    );
}

function ArtistSlide(props) {        
    let alt = props.d.Name;
    if (props.d.Artist) {
        alt += ' by ' + props.d.Artist.Name;
    }
    let titleClassName = 'artist__name';
    if (!props.multiline) {
        titleClassName += ' container--single__line';
    }        
    const link = `/artist/${props.d.Slug}`;

    return (
        <div className="slider__slide" style={props.style}>
            <div className="artist__container">
                <LinkedImage
                    type="fill"
                    alt={alt}
                    title={props.d.Title}
                    cols={5}
                    slider={true}
                    image={props.d.Image}
                    imageClass="artist__img"
                    link={link}
                    {...props}
                />
                <div className="artist__details">
                    <a href={link}>
                        <h4 className={titleClassName}>{props.d.Name}</h4>
                    </a>
                    <FollowButton
                        data={props.d}
                        onChange={props.onFollowChange}
                        />
                </div>
            </div>
        </div>
    );
}

function ArtistSlim(props) {
    return (<div className="grid grid--3">
        <div className="artist__grid artist__grid--slim">
            <div className="artist__info">
                {props.d.IsInGraph ? <a href={`/artist/${props.d.Slug}`} className="box--artist__title">
                    <div className="container--single__line">{props.d.Name}</div>
                </a> : <div className="box--artist__title">
                    <div className="container--single__line" style={{color: 'lightgrey'}}>{props.d.Name}</div>
                </div>
                }
                {/* {props.d.Reps && props.d.Reps.map((rep, i) =>
                    <a key={rep.Slug} href={`/gallery/${rep.Slug}`} style={{fontSize: '8px', color: rep.IsGhost ? 'red' : rep.IsOpted ? 'green' : 'blue'}}>{rep.Company},</a>
                )} */}
            </div>
        </div>
    </div>);
}

function Artwork(props) {
    const link = `/art/${props.d.Slug}`;
    let title = (
        <span className="art__title">
            {props.d.Title}
            <span className="art__subtitle">{props.d.Subtitle}</span>
        </span>
    );
    let dimensions = <span>{props.d.Dimensions}</span>;
    let displayPrice = <span>{props.d.DisplayPrice}</span>;
    if (props.d.IsOpted) {
        dimensions = <a href={link}>{dimensions}</a>;
        displayPrice = <a href={link}>{displayPrice}</a>;
        title = <a href={link}>{title}</a>;
    }
    let className = 'art__container art--adapt';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <div className={className}>
            <LinkedImage
                alt={props.d.alt}
                cols={props.cols}
                containerRef={props.containerRef}
                gutter={props.gutter}
                image={props.d.Image}
                imageClass="artist__img"
                link={props.d.IsOpted ? link : false}
                title={props.d.Title}
                type="pad"
                {...props}
            />
            <div className="art__info">
                {props.d.ArtId === 3991804 && <div><strong>🥇 First Place: Open Call 2023</strong></div>}
                {props.d.ArtId === 3893084 && <div><strong>🥈 Second Place: Open Call 2023</strong></div>}
                {props.d.ArtId === 3894404 && <div><strong>🥉 Third Place: Open Call 2023</strong></div>}
                {props.d.Artist && (
                    <a href={`/artist/${props.d.Artist.Slug}`}>
                        <span className="art__user">
                            {props.d.Artist.Name}
                        </span>
                    </a>
                )}
                {props.onLikeChange && (
                    <FollowButton
                        data={props.d}
                        type="like"
                        onChange={props.onLikeChange}
                    />
                )}
                {title}
                <span className="art__details">
                    {dimensions}
                    {displayPrice}
                    {props.d.Gallery && (
                        <a href={`/gallery/${props.d.Gallery.Slug}`}>
                            <span>{props.d.Gallery.Company}</span>
                        </a>
                    )}
                </span>
            </div>
        </div>
    );
}

function ArtworkSlide(props) {
    const imageHeight = props.height || 250;

    let alt = props.d.Title;
    if (props.d.Artist) {
        alt += ' by ' + props.d.Artist.Name;
    }
    const link = `/art/${props.d.Slug}`;

    return (
        <div className="item" style={{ ...props.style }}>
            <div className="art__container">
                <LinkedImage
                    type="pad"
                    alt={alt}
                    title={props.d.Title}
                    height={imageHeight}
                    image={props.d.Image}
                    imageClass="art__img"
                    link={link}
                    cols={4}
                    {...props}
                />

                {props.renderInfo != false && (
                    <div className="art__info">
                        {props.d.Artist && (
                            <a href={`/artist/${props.d.Artist.Slug}`}>
                                <span className="art__user">
                                    {props.d.Artist.Name}
                                </span>
                            </a>
                        )}
                        <FollowButton
                            data={props.d}
                            type="like"
                            onChange={props.onLikeChange}
                        />
                        <a href={link}>
                            <span className="art__title">
                                {props.d.Title}
                                <span className="art__subtitle">
                                    {props.d.Subtitle}
                                </span>
                            </span>
                        </a>
                        <span className="art__details">
                            <span>{props.d.Dimensions}</span>
                            <span>{props.d.DisplayPrice}</span>
                            {props.d.Gallery && (
                                <a
                                    href={`/gallery/${props.d.Gallery.Slug}`}
                                >
                                    {props.d.Gallery.Company}
                                </a>
                            )}
                        </span> 
                    </div>
                )}
            </div>
        </div>
    );
}

function City(props) {
    const link = `/city/${props.d.Slug || props.d.Name}`;
    return (
        <div className="grid grid--3">
            <div className="gallery__grid">
                <LinkedImage
                    alt={props.d.Name}
                    imageClass={"gallery__img"}
                    image={props.d.Image}
                    link={link}
                    type={"fill"}
                    cols={4}
                    {...props}
                />
                <div className="gallery__info">
                    <a href={link}>
                        <h4>{props.d.Name}</h4>
                    </a>
                </div>
            </div>
        </div>
    );
}

function CitySlide(props) {
    const link = `/city/${props.d.Name}`;
    return (
        <div className="slider__slide">
            <div className="show--block">
                <LinkedImage
                    alt={props.d.Name}
                    imageClass={"gallery__img"}
                    image={props.d.Image}
                    link={link}
                    type={"fill"}
                    cols={3}
                    slider={true}
                    {...props}
                />
                <div className="gallery__info">
                    <a href={link}>
                        <h4>{props.d.Name}</h4>
                    </a>
                </div>
            </div>
        </div>
    );
}

function Gallery(props) {
    const link = `/gallery/${props.d.Slug}`;
    let titleClassName;
    if (!props.multiline) {
        titleClassName = 'container--single__line';
    }

    let titleLetters;
    if (props.d.Company) {
        var split = props.d.Company.split(' ');
        var letters = split.map(val => val[0]);
        titleLetters = letters.join('');
    }
    return (
        <div className="gallery__grid grid grid--4">
            <LinkedImage
                alt={props.d.Company}
                imageClass={"gallery__img"}
                image={props.d.Image}
                link={link}
                noImage={(
                    <div className="cover__img--blank">
                        <div className="cover__img--blank__inn">
                            <span className="i i--gallery"></span>
                            <span className="cover__img__text">{titleLetters}</span>
                        </div>
                    </div>
                )}
                type={"fill"}
                cols={3}
                {...props}
            />
            <div className="gallery__info">
                <a href={link}>
                    <h4 className={titleClassName}>{props.d.Company}</h4>
                </a>
                <span className="gallery__location">{props.d.Location}</span>
                <FollowButton data={props.d} onChange={props.onFollowChange} />
            </div>
        </div>
    );
}

function GalleryProspect(props) {
    const company = (props.d.Company || `<No Company> (${props.d.GalleryId})`) + ` (${props.d.GalleryId})`;
    return (<div className="grid grid--3">
        <div className="artist__grid artist__grid--slim">
            <div className="artist__info">
                <a target="_blank" href={`/gallery/${props.d.Slug}`}>
                    <div>
                        <strong>{company}</strong>
                    </div>
                </a>
                <div>Location: {props.d.Location}</div>
                <div className="cursor-pointer"><u onClick={props.handleOpen}>Degree: {props.d.Degree}</u></div>
                <div>Ghost: {props.d.Ghost}</div>
                <div>EverActivated: {props.d.EverActivated ? 'Yes' : 'No'}</div>
                <ul>
                    <_GalleryLiUrl Label={"Artcloud"} Href={props.d.Urls.Artcloud} />
                    <_GalleryLiUrl Label={"HubSpot"} Href={props.d.Urls.HubSpot} />
                    <_GalleryLiUrl Label={"Artsy"} Href={props.d.Urls.Artsy} />
                    <_GalleryLiUrl Label={"Website"} Href={props.d.Urls.Website} />
                </ul>
            </div>
        </div>
    </div>);
}

function _GalleryLiUrl(props) {
    return <li><a style={{ 'color': (props.Href ? 'green' : '') }} target="_blank" href={props.Href}>{props.Label}</a></li>;
}

function GallerySlide(props) {
    const link = `/gallery/${props.d.Slug}`;
    return (
        <div className="slider__slide">
            <div className="show--block">
                <LinkedImage
                    alt={props.d.Company}
                    imageClass={"gallery__img"}
                    image={props.d.Image}
                    link={link}
                    type={"fill"}
                    cols={3}
                    slider={true}
                    {...props}
                />
                <div className="gallery__info">
                    <a href={link}>
                        <h4>{props.d.Company}</h4>
                    </a>
                    <span className="gallery__location">
                        {props.d.Location}
                    </span>
                    <FollowButton
                        data={props.d}
                        onChange={props.onFollowChange}
                    />
                </div>
            </div>
        </div>
    );
}

function Profile(props) {
    const link = `/profile/${props.d.ProfileId}`;
    let image;
    let imageClassName;
    if (
        props.d.Image &&
        props.d.Image.SmallUrl &&
        props.d.Image.SmallUrl.length
    ) {
        image = props.d.Image.SmallUrl;
    } else {
        image = '/assets/img/logos/footer-mark.svg';
        imageClassName = 'default-img';
    }
    return (
        <div className="profile__grid__cont grid grid--3">
            <div className="profile__grid">
                <a href={link}>
                    <div className="profile__mark profile__mark--img">
                        <img
                            alt={props.d.Name}
                            className={imageClassName}
                            src={image}
                        />
                    </div>
                </a>
                <div className="profile__info">
                    <a href={link}>
                        <h4>{props.d.Name}</h4>
                    </a>
                    <span className="user__label">
                        {props.d.Favorites} artwork
                        {props.d.Favorites == 1 ? '' : 's'} saved
                    </span>
                </div>
            </div>
        </div>
    );
}

function ProfileSlide(props) {
    let profiles;
    if (props.d.profiles) {
        profiles = props.d.profiles.map((d) => (
            <a
                href={`/profile/${d.ProfileId}`}
                className="user__anchor user--inline"
                key={d.ProfileId}
            >
                <img
                    className="user__img"
                    src={d.Image ? d.Image.SmallUrl : undefined}
                    alt={d.Name}
                />
                <span className="user__name">{d.Name}</span>
                <span className="user__label">
                    {d.Favorites} artwork{d.Favorites != 1 ? 's' : ''} saved
                </span>
            </a>
        ));
    }
    return <div className="slider__slide">{profiles}</div>;
}

function ShowFixed(props) {
    let imageStyle;
    if (props.d.Image) {
        if (!props.d.ImgSrc) {
            const height = props.height || 200.0;
            props.d.Height = height;
            if (props.width) {
                props.d.Width = props.width;
            } else {
                const ratio = props.d.Image.Width / props.d.Image.Height;
                props.d.Width = Math.floor(height * ratio);
            }
            let width = null;
            if (props.setWidth != false) {
                width = props.d.Width;
            }
            let transform = 'c_fill';
            props.d.ImgSrc = Artcloud.cdn.url(
                props.d.Image.S3Id,
                width,
                props.d.Height,
                transform
            );
        }
        imageStyle = {
            backgroundColor: `rgb(${props.d.Image.PrimaryR},${props.d.Image.PrimaryG},${props.d.Image.PrimaryB})`,
            backgroundImage: `url('${props.d.ImgSrc}')`,
        };
    }
    return (
        <div className="grid grid--3">
            <div className="show__grid">
                <a href={`/show/${props.d.Slug}`}>
                    <div className="gallery__img--cover" style={imageStyle} />
                </a>
                <ShowInfo wrap={false} {...props} />
            </div>
        </div>
    );
}

function ShowHorizontal(props) {
    let className;
    if (props.inline) {
        className = 'show--inline';
    } else {
        className = 'show__box';
    }
    return (
        <div className="grid grid--6">
            <div className="show__item">
                <div className={className}>
                    <LinkedImage
                        alt={props.d.Title}
                        imageClass={"show__img"}
                        placeholderClass={"show__img"}
                        image={props.d.Image}
                        link={`/show/${props.d.Slug}`}
                        type={"pad"}
                        cols={3}
                        targetPosition="absolute"
                        {...props}
                    />
                    <ShowInfo {...props} />
                </div>
            </div>
        </div>
    );
}

function ShowInfo(props) {
    let titleClassName = 'show__title';
    if (!props.multiline) {
        titleClassName += ' container--single__line';
    }
    const content = (
        <div className="show__info__inner">
            <a href={`/show/${props.d.Slug}`}>
                <h4 className={titleClassName}>{props.d.Title}</h4>
            </a>
            {props.d.Gallery && (
                <a
                    href={`/gallery/${props.d.Gallery.Slug}`}
                    style={{ fontWeight: 'initial' }}
                >
                    <div className="show__label">{props.d.Gallery.Company}</div>
                </a>
            )}
            <span className="show__date">{props.d.Date}</span>
        </div>
    );
    if (props.wrap == false) {
        return content;
    }
    return <div className="show__info">{content}</div>;
}

function ShowVertical(props) {
    const link = `/show/${props.d.Slug}`;
    return (
        <div className="item">
            <div className="show--block">
                <LinkedImage
                    alt={props.d.Title}
                    image={props.d.Image}
                    height={250}
                    link={link}
                    type={"fill"}
                    cols={2}
                    slider={true}
                    {...props}
                />
                <ShowInfo {...props} />
            </div>
        </div>
    );
}

export {
    Artist,
    ArtistSlide,
    ArtistSlim,
    Artwork,
    ArtworkSlide,
    City,
    CitySlide,
    Gallery,
    GalleryProspect,
    GallerySlide,
    Profile,
    ProfileSlide,
    ShowFixed,
    ShowHorizontal,
    ShowInfo,
    ShowVertical,
};
